interface SectionLabelProps {
  index: string;
  label: string;
}

export default function SectionLabel({ index, label }: SectionLabelProps) {
  return (
    <p className="font-label text-xs uppercase tracking-[0.14em] text-foreground-800">
      <span className="text-primary-500">{index}</span>
      <span className="mx-2 text-foreground-500">/</span>
      {label}
    </p>
  );
}